import enPlatformPayment from './en/platformPayment'
import enPlatformOrders from './en/platformOrders'
import zhCNPlatformOrders from './zh-CN/platformOrders'
import enCheckout from './en/checkout'
import zhCNCheckout from './zh-CN/checkout'
import zhCNPlatformPayment from './zh-CN/platformPayment'
import enSxaConfig from './en/sxaConfig'
import zhCNSxaConfig from './zh-CN/sxaConfig'
import enSxaNews from './en/sxaNews'
import zhCNSxaNews from './zh-CN/sxaNews'
import enSxaActivities from './en/sxaActivities'
import zhCNSxaActivities from './zh-CN/sxaActivities'
import enSxaMine from './en/sxaMine'
import zhCNSxaMine from './zh-CN/sxaMine'
import enSxaHome from './en/sxaHome'
import zhCNSxaHome from './zh-CN/sxaHome'
import enSxaMembers from './en/sxaMembers'
import zhCNSxaMembers from './zh-CN/sxaMembers'
import enSxaEnterprise from './en/sxaEnterprise'
import zhCNSxaEnterprise from './zh-CN/sxaEnterprise'
import enAssociationAdmin from './en/associationAdmin'
import zhCNAssociationAdmin from './zh-CN/associationAdmin'
import enMemberAdmin from './en/memberAdmin'
import zhCNMemberAdmin from './zh-CN/memberAdmin'
import enUserManage from './en/userManage'
import zhCNUserManage from './zh-CN/userManage'
import { createI18n } from 'vue-i18n'
import { DEFAULT_LOCALE, FALLBACK_LOCALE, readStoredLocale } from '@/constants/locale'

import zhCNCommon from './zh-CN/common'
import zhCNNav from './zh-CN/nav'
import zhCNLayout from './zh-CN/layout'
import zhCNConference from './zh-CN/conference'
import zhCNLottery from './zh-CN/lottery'
import zhCNRoute from './zh-CN/route'
import zhCNMicrosite from './zh-CN/microsite'
import zhCNRegistration from './zh-CN/registration'
import zhCNParticipant from './zh-CN/participant'
import zhCNForbidden from './zh-CN/forbidden'
import zhCNMemberPlan from './zh-CN/memberPlan'
import zhCNMemberHub from './zh-CN/memberHub'
import zhCNRechargePackages from './zh-CN/rechargePackages'
import zhCNSxaDemands from './zh-CN/sxaDemands'
import zhCNVoting from './zh-CN/voting'
import zhCNCloudSpace from './zh-CN/cloudSpace'
import zhCNRechargeAdmin from './zh-CN/rechargeAdmin'

import enCommon from './en/common'
import enNav from './en/nav'
import enLayout from './en/layout'
import enConference from './en/conference'
import enLottery from './en/lottery'
import enRoute from './en/route'
import enMicrosite from './en/microsite'
import enRegistration from './en/registration'
import enParticipant from './en/participant'
import enForbidden from './en/forbidden'
import enMemberPlan from './en/memberPlan'
import enMemberHub from './en/memberHub'
import enRechargePackages from './en/rechargePackages'
import enSxaDemands from './en/sxaDemands'
import enVoting from './en/voting'
import enCloudSpace from './en/cloudSpace'
import enRechargeAdmin from './en/rechargeAdmin'

const zhCNMessages = {
  platformPayment: zhCNPlatformPayment,
  platformOrders: zhCNPlatformOrders,
  checkout: zhCNCheckout,
  sxaConfig: zhCNSxaConfig,
  sxaNews: zhCNSxaNews,
  sxaActivities: zhCNSxaActivities,
  sxaMine: zhCNSxaMine,
  sxaHome: zhCNSxaHome,
  sxaMembers: zhCNSxaMembers,
  sxaEnterprise: zhCNSxaEnterprise,
  associationAdmin: zhCNAssociationAdmin,
  memberAdmin: zhCNMemberAdmin,
  userManage: zhCNUserManage,
  rechargeAdmin: zhCNRechargeAdmin,
  cloudSpace: zhCNCloudSpace,
  voting: zhCNVoting,
  common: zhCNCommon,
  nav: zhCNNav,
  layout: zhCNLayout,
  conference: {
    ...zhCNConference,
    lottery: zhCNLottery
  },
  route: zhCNRoute,
  microsite: zhCNMicrosite,
  registration: zhCNRegistration,
  participant: zhCNParticipant,
  forbidden: zhCNForbidden,
  memberPlan: zhCNMemberPlan,
  memberHub: zhCNMemberHub,
  rechargePackages: zhCNRechargePackages,
  sxaDemands: zhCNSxaDemands
}

const enMessages = {
  platformPayment: enPlatformPayment,
  platformOrders: enPlatformOrders,
  checkout: enCheckout,
  sxaConfig: enSxaConfig,
  sxaNews: enSxaNews,
  sxaActivities: enSxaActivities,
  sxaMine: enSxaMine,
  sxaHome: enSxaHome,
  sxaMembers: enSxaMembers,
  sxaEnterprise: enSxaEnterprise,
  associationAdmin: enAssociationAdmin,
  memberAdmin: enMemberAdmin,
  userManage: enUserManage,
  rechargeAdmin: enRechargeAdmin,
  cloudSpace: enCloudSpace,
  voting: enVoting,
  common: enCommon,
  nav: enNav,
  layout: enLayout,
  conference: {
    ...enConference,
    lottery: enLottery
  },
  route: enRoute,
  microsite: enMicrosite,
  registration: enRegistration,
  participant: enParticipant,
  forbidden: enForbidden,
  memberPlan: enMemberPlan,
  memberHub: enMemberHub,
  rechargePackages: enRechargePackages,
  sxaDemands: enSxaDemands
}

const messages = {
  'zh-CN': zhCNMessages,
  en: enMessages
}

const i18n = createI18n({
  legacy: false,
  locale: readStoredLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages
})

export default i18n

/** Element Plus 语言包映射 */
export const elementPlusLocaleMap = {
  'zh-CN': () => import('element-plus/es/locale/lang/zh-cn'),
  en: () => import('element-plus/es/locale/lang/en')
}

export async function loadElementPlusLocale (locale) {
  const loader = elementPlusLocaleMap[locale] || elementPlusLocaleMap[DEFAULT_LOCALE]
  const mod = await loader()
  return mod.default
}
